export const addClickListener = (callback) => {
  document.body.addEventListener("click", callback, true);
};

export const removeClickListener = (callback) => {
  if (callback) {
    document.body.removeEventListener("click", callback, true);
  }
};
